import classNames from "classnames";
import styles from "./divider.module.scss";
import { ComponentConfig } from "@measured/puck";

export interface DividerProps {
  variant?: "primary" | "gray" | "pink";
}

const Divider = (props: DividerProps) => {
  return (
    <div
      className={classNames(styles.container, {
        [styles.primary]: props.variant === "primary",
        [styles.gray]: props.variant === "gray",
        [styles.pink]: props.variant === "pink",
      })}
    />
  );
};

export const PuckDivider: ComponentConfig<DividerProps> = {
  label: "Divider",
  fields: {
    variant: {
      type: "select",
      label: "Variant",
      options: [
        { value: "primary", label: "Primary" },
        { value: "gray", label: "Gray" },
        { value: "pink", label: "Pink" },
      ],
    },
  },
  defaultProps: {
    variant: "primary",
  },
  render: (props) => <Divider {...props} />,
};
